import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function AdminIcon(props, ref) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "m12 4.236-6 3V12c0 5.156 4.239 7.254 6 7.898 1.761-.644 6-2.742 6-7.898V7.236l-6-3Zm-.894-1.789a2 2 0 0 1 1.788 0l6 3A2 2 0 0 1 20 7.236V12c0 6.742-5.773 9.246-7.51 9.846-.32.111-.66.111-.98 0C9.774 21.246 4 18.742 4 12V7.236a2 2 0 0 1 1.106-1.789l6-3Z",
      clipRule: "evenodd"
    })
  });
}
;
AdminIcon.displayName = "AdminIcon";
export default forwardRef(AdminIcon);